// extracted by mini-css-extract-plugin
export var fadeIn = "_if-1";
export var modalContent = "_if-3";
export var overlay = "_if-0";
export var popoverContent = "_if-2";
export var results = "_if-5";
export var searchInputWrapper = "_if-4";